import React from 'react';
import { HardHat } from 'lucide-react';
import ComingSoonPage from '../components/ComingSoonPage';

export default function SupervisorsPage() {
  return (
    <ComingSoonPage
      testId="supervisors-page"
      title="Supervisors"
      arabicTitle="المشرفون"
      icon={HardHat}
      accent="#6FA8FF"
      description="بيانات المشرفين وتغطيتهم للمناطق والمحافظات، مع مؤشرات إنجاز الفرق تحت إشرافهم."
    />
  );
}
